import React from 'react'
import { connect } from 'react-redux'

import {
  ORDER_ITEM_DETAIL,
  ORDER_ITEM_STATUS,
  ORDER_ITEM_STATUS_VALUE,
  STATUS,
} from '../../../../helpers'
import { IMG } from '../../../../themes'
import { MODAL, ORDER } from '../../../../reduxs'

import { OrderItemStyle } from './styles'

function OrderItem(props) {
  const {
    language,
    orderId,
    cateringDate,
    status,
    items,
    orderNumber,
    bookingDuration,
    colorTheme,
    selectedTab,
    setEditOrderHashMap,
    setOrderId,
    openOrderCounterModal,
    setIsEditOrder,
    setOrderActionEdit,
    setOrderActionCancel,
    openCancelOrderModal,
    rawBookingDetail,
    bookingDetail,
  } = props

  const isVisibleOrderActionButton = () => {
    const currentTime = new Date().getTime()
    
    return (
      currentTime < new Date(rawBookingDetail.endDatetime).getTime()
      )
    }
    
  const isDisabled = bookingDetail.status === STATUS.END_MEETING

  const handleEditOrder = (orderId) => {
    setEditOrderHashMap(orderId)
    setOrderId(orderId)
    setOrderActionEdit(selectedTab)
    setIsEditOrder(true)
    openOrderCounterModal()
  }

  const handleCancelOrder = (orderId) => {
    openCancelOrderModal()
    setOrderId(orderId)
    setOrderActionCancel(selectedTab)
  }

  return (
    <OrderItemStyle status={status} colorTheme={colorTheme} >
      <div className='order-item__box'>
        <div className='order-item__top-box'>
          <p className='order-item__order--number'>
            <span>
              {`${ORDER_ITEM_DETAIL.ORDER[language]} #${orderNumber}`}
            </span>
            <span className='order-item__order--status'>
              {ORDER_ITEM_STATUS[status].TEXT[language]}
            </span>
          </p>

          {isVisibleOrderActionButton() &&
          status === ORDER_ITEM_STATUS_VALUE.WAITING && 
            <div className='order-item__button'>
              <button
                className={`order-item__button--edit ${isDisabled ? 'disabled' : ''}`}
                onClick={() => handleEditOrder(orderId)}
                disabled={isDisabled}
              >
                {ORDER_ITEM_DETAIL.EDIT[language]}
              </button>
              <button
                className={`order-item__button--delete  ${isDisabled ? 'disabled' : ''} `}
                onClick={() => handleCancelOrder(orderId)}
                disabled={isDisabled}
              >
                <img src={IMG['red-trash.svg']} alt='trash' />
              </button>
            </div>
          }
        </div>

        <p className='order-item__order-duration'>
          {`${cateringDate} . ${bookingDuration}`}
        </p>
      </div>

      <div className='order-item__order-list'>
        {items.map((item) => {
          return(
            <div
              key={item.itemName}
              className='order-item__order-list__item'
            >
              <p className='order-item__order-list__item--name'>{item.itemName}</p>
              <p className='order-item__order-list__item--amount'>{item.amount}</p>
            </div>
          )
        })}
      </div>
    </OrderItemStyle>
  )
}

const mapStateToProps = ({ accountReducer, orderReducer, meetingReducer }) => {
  return {
    language: accountReducer.language,
    colorTheme: accountReducer.user.colorThemePalette,
    rawBookingDetail: meetingReducer.rawBookingDetail,
    bookingDetail: meetingReducer.bookingDetail,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setEditOrderHashMap: (orderId) => dispatch(ORDER.action.setEditOrderHashMap(orderId)),
    setOrderId: (orderId) => dispatch(ORDER.action.setOrderId({ orderId })),
    setOrderActionEdit: (selectedTab) => dispatch(ORDER.action.setOrderActionText(selectedTab, 'EDIT')),
    setOrderActionCancel: (selectedTab) => dispatch(ORDER.action.setOrderActionText(selectedTab, 'CANCEL')),
    openOrderCounterModal: () => dispatch(MODAL.action.setOrderCounterModal(true)),
    setIsEditOrder: (isEditOrder) => dispatch(ORDER.action.setIsEditOrder(isEditOrder)),
    openCancelOrderModal: () => dispatch(MODAL.action.setCancelOrderModal(true)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderItem)
